import { render, staticRenderFns } from "./PublicCoursewareStructuralElement.vue?vue&type=template&id=2a235fce&"
import script from "./PublicCoursewareStructuralElement.vue?vue&type=script&lang=js&"
export * from "./PublicCoursewareStructuralElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports